import { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { Row, Col, Card, CardBody, CardHeader } from 'reactstrap'
import brandit_rails from '../../api/brandit_rails'
import MfButton from '../branded/MfButton'
import SectionWithLabel from '../general/SectionWithLabel'

const AgencyShow = props => {
  const { id } = props.match.params

  const [agency, setAgency] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchAgency = async () => {
      try {
        const response = await brandit_rails.get(`/admin/organization/agencies/${id}`)
        setAgency(response.data)
        setLoading(false)
      } catch (error) {
        console.error(error)
        setLoading(false)
      }
    }
    fetchAgency()
  }, [id])

  if (loading) return <div>Loading...</div>

  return (
    <Card>
      <CardHeader>{agency.name}</CardHeader>
      <CardBody>
        <SectionWithLabel label="Agency Details">
          <Row>
            <Col>
              <dt>Agency Name</dt>
              <dd>{agency.name}</dd>
              <dt>MF Account Rep</dt>
              <dd>test</dd>
            </Col>
            <Col style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <MfButton component="dx" text="View in Hubspot" />
            </Col>
          </Row>
        </SectionWithLabel>
        <SectionWithLabel label="Owner Details">
          <Row>
            <Col>
              <dt>Owner Name</dt>
              <dd>{agency.owner_name}</dd>
              <dt>Owner Email</dt>
              <dd>{agency.owner_email}</dd>
            </Col>
          </Row>
        </SectionWithLabel>
        <SectionWithLabel label="Billing & Account Details">
          <Row>
            <Col>
              <dt>Plan</dt>
              <dd>{agency.agency_plan_name}</dd>
              <dt>Account Status</dt>
              <dd>{agency.account_status}</dd>
              <SectionWithLabel label="Trial Terms">
                <Row>
                  <Col>
                    <dt>Start Date</dt>
                    <dd>{agency.trial_start_date}</dd>
                  </Col>
                  <Col>
                    <dt>End Date</dt>
                    <dd>{agency.trial_end_date}</dd>
                  </Col>
                </Row>
              </SectionWithLabel>
            </Col>
            {/* <Col>
              <SectionWithLabel label="Selected Features">
                <Row>
                  <Col>
                    <dt>Feature 1</dt>
                    <dd>Feature 1</dd>
                    <dt>Feature 2</dt>
                    <dd>Feature 2</dd>
                  </Col>
                </Row>
              </SectionWithLabel>
            </Col> */}
          </Row>
        </SectionWithLabel>
        <SectionWithLabel label="Admin">
          <Row>
            <Col>
              <dt>Maintenance Mode</dt>
              <dd>{agency.maintenance_mode ? 'On' : 'Off'}</dd>
            </Col>
          </Row>
        </SectionWithLabel>
        <Row style={{ paddingTop: '1rem' }}>
          <Col className="d-flex justify-content-end">
            <MfButton component="dx" text="Edit Agency" onClick={() => props.history.push(`/agencies/${id}/edit`)} />
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default withRouter(AgencyShow)
